import { Paper } from "@deere/fuel-react";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

export interface NotificationItemProps {
  heading: string;
  message: string;
  iconBadge: React.ReactElement;
  date: string;
  isRead: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
}

const NotificationItem = ({
  heading,
  message,
  iconBadge,
  date,
  isRead,
  buttonText,
  onButtonClick,
}: NotificationItemProps) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 0,
        padding: theme.tokens.FuelSpacing4,
        marginBottom: 0.125,
        ...(!isRead && {
          borderLeft: `4px solid ${theme.tokens.FuelColorAlertInfoIcon}`,
          backgroundColor: theme.tokens.FuelColorAlertInfoBackground,
        }),
      }}
    >
      <div
        style={{
          display: "flex",
          gap: theme.tokens.FuelSpacing4,
          alignItems: "flex-start",
        }}
      >
        <div data-testid="icon">{iconBadge}</div>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: theme.tokens.FuelSpacing4,
            flex: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: theme.tokens.FuelSpacing1,
            }}
          >
            <Typography
              data-fuel-size="md"
              fontWeight={theme.tokens.FuelFontWeightBold}
              data-testid="notification-heading"
            >
              {heading}
            </Typography>
            <Typography
              data-fuel-size="sm"
              color={theme.tokens.FuelColorTextSecondary}
              data-testid="notification-message"
            >
              {message}
            </Typography>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              data-testid="notification-button"
              variant="text"
              size="small"
              sx={{
                color: theme.tokens.FuelColorGreen700,
                textTransform: "none",
              }}
              onClick={onButtonClick}
            >
              {buttonText}
            </Button>
            <Typography
              data-fuel-size="xs"
              color={theme.tokens.FuelColorTextSecondary}
              sx={{ whiteSpace: "nowrap" }}
              data-testid="notification-date"
            >
              {date}
            </Typography>
          </div>
        </Box>
      </div>
    </Paper>
  );
};

export default NotificationItem;
